import styled from 'styled-components'

export const Title = styled.h3`
  margin-bottom: 1rem;
  color: #1E8B98;
  font-weight: bold;
  text-align: center;
`
